module.exports = __webpack_public_path__ + "search.1cd38213f30e63ef3c9595d15634d6b6.svg";